import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "windowWrapper" }
const _hoisted_2 = { id: "window" }
const _hoisted_3 = {
  key: 'gameUpdates',
  class: "full-game full-screen-cover gradient-background"
}
const _hoisted_4 = {
  key: 0,
  class: "screen_size"
}
const _hoisted_5 = { id: "menu_BTN_div" }
const _hoisted_6 = {
  key: 1,
  class: "screen_size"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { id: "intro_desc_box" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { id: "intro_cont_pos" }
const _hoisted_12 = { id: "cont_BTN" }
const _hoisted_13 = {
  key: 2,
  class: "screen_size"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { id: "data_proc_box" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { id: "study_part_box" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { id: "study_BTN_box" }
const _hoisted_23 = {
  key: 0,
  class: "modal_background"
}
const _hoisted_24 = { id: "data_modal_box" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "modal_background"
}
const _hoisted_29 = { id: "study_modal_box" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { id: "study_modal_BTN_box" }
const _hoisted_33 = {
  key: 3,
  class: "screen_size"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { id: "name_char_box" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = {
  key: 0,
  id: "name_cont_pos"
}
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  key: 4,
  class: "screen_size"
}
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { id: "scene_1_pos" }
const _hoisted_43 = { id: "card_hover_wrap" }
const _hoisted_44 = { id: "card_box" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { id: "scene_2_pos" }
const _hoisted_48 = { id: "card_hover_wrap" }
const _hoisted_49 = { id: "card_box" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { id: "scene_3_pos" }
const _hoisted_53 = { id: "card_hover_wrap" }
const _hoisted_54 = { id: "card_box" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = {
  key: 5,
  class: "screen_size"
}
const _hoisted_58 = { id: "dialogue_scores" }
const _hoisted_59 = { id: "rela_ring" }
const _hoisted_60 = { id: "fair_ring" }
const _hoisted_61 = { id: "equit_ring" }
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { id: "speaker_IMG" }
const _hoisted_66 = {
  key: 0,
  id: "tribal_IMG"
}
const _hoisted_67 = {
  key: 1,
  id: "rawiri_IMG"
}
const _hoisted_68 = {
  key: 2,
  id: "gov_IMG"
}
const _hoisted_69 = {
  key: 3,
  id: "jas_IMG"
}
const _hoisted_70 = {
  key: 4,
  id: "tribal2_IMG"
}
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = { id: "choices_layout" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = { id: "dialogue_container" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = {
  key: 0,
  id: "context_icon"
}
const _hoisted_78 = { id: "dialogue_cont_pos" }
const _hoisted_79 = {
  key: 1,
  id: "meeting_background"
}
const _hoisted_80 = {
  key: 2,
  id: "gov_background"
}
const _hoisted_81 = {
  key: 3,
  id: "board_background"
}
const _hoisted_82 = {
  key: 6,
  class: "screen_size"
}
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = { id: "dialogue_cont_pos" }
const _hoisted_86 = { class: "budget-slider-container" }
const _hoisted_87 = { class: "budget-slider-amount" }
const _hoisted_88 = { id: "slider_max" }
const _hoisted_89 = {
  key: 0,
  class: "modal_background"
}
const _hoisted_90 = { id: "no_budget_modal_box" }
const _hoisted_91 = { id: "no_budget_title" }
const _hoisted_92 = { id: "no_budget_desc" }
const _hoisted_93 = ["innerHTML"]
const _hoisted_94 = {
  key: 7,
  class: "screen_size"
}
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = { id: "allocation_grid_box" }
const _hoisted_98 = { class: "alloc_type_box row-1 column-1" }
const _hoisted_99 = { id: "type_title" }
const _hoisted_100 = ["innerHTML"]
const _hoisted_101 = { class: "alloc_type_box row-2 column-1" }
const _hoisted_102 = { id: "type_title" }
const _hoisted_103 = ["innerHTML"]
const _hoisted_104 = { class: "alloc_type_box row-3 column-1" }
const _hoisted_105 = { id: "type_title" }
const _hoisted_106 = ["innerHTML"]
const _hoisted_107 = { class: "alloc_adds_box row-1 column-2" }
const _hoisted_108 = ["innerHTML"]
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = { id: "adds_BTN_box" }
const _hoisted_111 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_112 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_113 = { class: "alloc_adds_box row-1 column-3" }
const _hoisted_114 = ["innerHTML"]
const _hoisted_115 = ["innerHTML"]
const _hoisted_116 = { id: "adds_BTN_box" }
const _hoisted_117 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_118 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_119 = { class: "alloc_adds_box row-1 column-4" }
const _hoisted_120 = ["innerHTML"]
const _hoisted_121 = ["innerHTML"]
const _hoisted_122 = { id: "adds_BTN_box" }
const _hoisted_123 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_124 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_125 = { class: "alloc_adds_box row-1 column-5" }
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = ["innerHTML"]
const _hoisted_128 = { id: "adds_BTN_box" }
const _hoisted_129 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_130 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_131 = { class: "alloc_adds_box row-2 column-2" }
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = ["innerHTML"]
const _hoisted_134 = { id: "adds_BTN_box" }
const _hoisted_135 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_136 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_137 = { class: "alloc_adds_box row-2 column-3" }
const _hoisted_138 = ["innerHTML"]
const _hoisted_139 = ["innerHTML"]
const _hoisted_140 = { id: "adds_BTN_box" }
const _hoisted_141 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_142 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_143 = { class: "alloc_adds_box row-2 column-4" }
const _hoisted_144 = ["innerHTML"]
const _hoisted_145 = ["innerHTML"]
const _hoisted_146 = { id: "adds_BTN_box" }
const _hoisted_147 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_148 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_149 = { class: "alloc_adds_box row-2 column-5" }
const _hoisted_150 = ["innerHTML"]
const _hoisted_151 = ["innerHTML"]
const _hoisted_152 = { id: "adds_BTN_box" }
const _hoisted_153 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_154 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_155 = { class: "alloc_adds_box row-3 column-2" }
const _hoisted_156 = ["innerHTML"]
const _hoisted_157 = ["innerHTML"]
const _hoisted_158 = { id: "adds_BTN_box" }
const _hoisted_159 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_160 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_161 = { class: "alloc_adds_box row-3 column-3" }
const _hoisted_162 = ["innerHTML"]
const _hoisted_163 = ["innerHTML"]
const _hoisted_164 = { id: "adds_BTN_box" }
const _hoisted_165 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_166 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_167 = { class: "alloc_adds_box row-3 column-4" }
const _hoisted_168 = ["innerHTML"]
const _hoisted_169 = ["innerHTML"]
const _hoisted_170 = { id: "adds_BTN_box" }
const _hoisted_171 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_172 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_173 = { class: "alloc_adds_box row-3 column-5" }
const _hoisted_174 = ["innerHTML"]
const _hoisted_175 = ["innerHTML"]
const _hoisted_176 = { id: "adds_BTN_box" }
const _hoisted_177 = {
  key: 1,
  id: "adds_sub_BTN_nil"
}
const _hoisted_178 = {
  key: 3,
  id: "adds_add_BTN_nil"
}
const _hoisted_179 = { id: "alloc_remaining" }
const _hoisted_180 = { id: "remain_box" }
const _hoisted_181 = ["innerHTML"]
const _hoisted_182 = { id: "remain_spent" }
const _hoisted_183 = { id: "remain_outOf" }
const _hoisted_184 = { id: "dialogue_cont_pos" }
const _hoisted_185 = {
  key: 0,
  class: "modal_background"
}
const _hoisted_186 = { id: "study_modal_box" }
const _hoisted_187 = { id: "confirm_modal_title" }
const _hoisted_188 = { id: "study_modal_desc" }
const _hoisted_189 = { id: "study_modal_BTN_box" }
const _hoisted_190 = {
  key: 8,
  class: "screen_size"
}
const _hoisted_191 = ["innerHTML"]
const _hoisted_192 = ["innerHTML"]
const _hoisted_193 = { id: "survey_def_box" }
const _hoisted_194 = { id: "survey_def_row" }
const _hoisted_195 = ["innerHTML"]
const _hoisted_196 = ["innerHTML"]
const _hoisted_197 = { id: "survey_def_row" }
const _hoisted_198 = ["innerHTML"]
const _hoisted_199 = ["innerHTML"]
const _hoisted_200 = { id: "survey_def_row" }
const _hoisted_201 = ["innerHTML"]
const _hoisted_202 = ["innerHTML"]
const _hoisted_203 = { id: "survey_def_row" }
const _hoisted_204 = ["innerHTML"]
const _hoisted_205 = ["innerHTML"]
const _hoisted_206 = { id: "survey_def_row" }
const _hoisted_207 = ["innerHTML"]
const _hoisted_208 = ["innerHTML"]
const _hoisted_209 = { id: "survey_def_row" }
const _hoisted_210 = ["innerHTML"]
const _hoisted_211 = ["innerHTML"]
const _hoisted_212 = { id: "survey_def_row" }
const _hoisted_213 = ["innerHTML"]
const _hoisted_214 = ["innerHTML"]
const _hoisted_215 = { id: "survey_def_row" }
const _hoisted_216 = ["innerHTML"]
const _hoisted_217 = ["innerHTML"]
const _hoisted_218 = { id: "dialogue_cont_pos" }
const _hoisted_219 = {
  key: 9,
  class: "screen_size"
}
const _hoisted_220 = ["innerHTML"]
const _hoisted_221 = ["innerHTML"]
const _hoisted_222 = ["innerHTML"]
const _hoisted_223 = ["innerHTML"]
const _hoisted_224 = { id: "survey_container" }
const _hoisted_225 = { id: "survey_choice_box" }
const _hoisted_226 = ["value"]
const _hoisted_227 = ["value"]
const _hoisted_228 = { id: "survey_choice_box" }
const _hoisted_229 = ["value"]
const _hoisted_230 = ["value"]
const _hoisted_231 = { id: "survey_choice_box" }
const _hoisted_232 = ["value"]
const _hoisted_233 = ["value"]
const _hoisted_234 = { id: "survey_next_pos" }
const _hoisted_235 = {
  key: 1,
  id: "next_BTN_style_disabled"
}
const _hoisted_236 = {
  key: 10,
  class: "screen-size"
}
const _hoisted_237 = ["innerHTML"]
const _hoisted_238 = {
  key: 0,
  id: "stage_text_box"
}
const _hoisted_239 = ["innerHTML"]
const _hoisted_240 = {
  key: 1,
  id: "stage_rela_container"
}
const _hoisted_241 = { id: "stage_rela_ring" }
const _hoisted_242 = ["innerHTML"]
const _hoisted_243 = {
  key: 2,
  id: "stage_fair_container"
}
const _hoisted_244 = { id: "stage_fair_ring" }
const _hoisted_245 = ["innerHTML"]
const _hoisted_246 = {
  key: 3,
  id: "stage_equit_container"
}
const _hoisted_247 = { id: "stage_equit_ring" }
const _hoisted_248 = ["innerHTML"]
const _hoisted_249 = ["innerHTML"]
const _hoisted_250 = {
  key: 2,
  id: "survey_rank_box"
}
const _hoisted_251 = { id: "survey_rank_container" }
const _hoisted_252 = { id: "survey_rank_row" }
const _hoisted_253 = { id: "survey_rank_row" }
const _hoisted_254 = { id: "survey_rank_row" }
const _hoisted_255 = { id: "survey_rank_row" }
const _hoisted_256 = { id: "survey_rank_row" }
const _hoisted_257 = { id: "survey_rank_row" }
const _hoisted_258 = { id: "survey_rank_row" }
const _hoisted_259 = ["innerHTML"]
const _hoisted_260 = {
  key: 3,
  id: "stage_text_box2"
}
const _hoisted_261 = ["innerHTML"]
const _hoisted_262 = {
  key: 1,
  id: "stage_rela_container"
}
const _hoisted_263 = { id: "stage_rela_ring" }
const _hoisted_264 = ["innerHTML"]
const _hoisted_265 = {
  key: 2,
  id: "stage_fair_container"
}
const _hoisted_266 = { id: "stage_fair_ring" }
const _hoisted_267 = ["innerHTML"]
const _hoisted_268 = {
  key: 3,
  id: "stage_equit_container"
}
const _hoisted_269 = { id: "stage_equit_ring" }
const _hoisted_270 = ["innerHTML"]
const _hoisted_271 = { key: 4 }
const _hoisted_272 = { id: "stage_text_layout" }
const _hoisted_273 = ["innerHTML"]
const _hoisted_274 = ["innerHTML"]
const _hoisted_275 = { id: "reward_IMG" }
const _hoisted_276 = {
  key: 0,
  id: "stage_silver"
}
const _hoisted_277 = {
  key: 1,
  id: "stage_gold"
}
const _hoisted_278 = {
  key: 2,
  id: "stage_bronze"
}
const _hoisted_279 = { key: 3 }
const _hoisted_280 = { key: 5 }
const _hoisted_281 = { id: "stage_cont_pos" }
const _hoisted_282 = ["innerHTML"]
const _hoisted_283 = {
  key: 11,
  class: "screen_size"
}
const _hoisted_284 = { id: "comp_overall" }
const _hoisted_285 = ["innerHTML"]
const _hoisted_286 = ["innerHTML"]
const _hoisted_287 = ["innerHTML"]
const _hoisted_288 = { id: "overall_tiki_container" }
const _hoisted_289 = {
  key: 0,
  id: "overall_gold_IMG"
}
const _hoisted_290 = {
  key: 1,
  id: "overall_silver_IMG"
}
const _hoisted_291 = {
  key: 2,
  id: "overall_bronze_IMG"
}
const _hoisted_292 = ["innerHTML"]
const _hoisted_293 = ["innerHTML"]
const _hoisted_294 = { id: "overall_rings_box" }
const _hoisted_295 = { id: "overall_rings_frame" }
const _hoisted_296 = { id: "overall_ring" }
const _hoisted_297 = { id: "overall_rings_title" }
const _hoisted_298 = { id: "overall_rings_frame" }
const _hoisted_299 = { id: "overall_ring" }
const _hoisted_300 = { id: "overall_rings_title" }
const _hoisted_301 = { id: "overall_rings_frame" }
const _hoisted_302 = { id: "overall_ring" }
const _hoisted_303 = { id: "overall_rings_title" }
const _hoisted_304 = { id: "completion_BTN_box" }
const _hoisted_305 = { id: "comp_levels_scroll" }
const _hoisted_306 = { id: "comp_level_container" }
const _hoisted_307 = ["innerHTML"]
const _hoisted_308 = { id: "comp_l1_scores" }
const _hoisted_309 = { id: "comp_scores_row" }
const _hoisted_310 = { id: "comp_ring" }
const _hoisted_311 = { id: "comp_desc_rows" }
const _hoisted_312 = { id: "comp_scores_title" }
const _hoisted_313 = ["innerHTML"]
const _hoisted_314 = { id: "comp_scores_row" }
const _hoisted_315 = { id: "comp_ring" }
const _hoisted_316 = { id: "comp_desc_rows" }
const _hoisted_317 = { id: "comp_scores_title" }
const _hoisted_318 = ["innerHTML"]
const _hoisted_319 = { id: "comp_scores_row" }
const _hoisted_320 = { id: "comp_ring" }
const _hoisted_321 = { id: "comp_desc_rows" }
const _hoisted_322 = { id: "comp_scores_title" }
const _hoisted_323 = ["innerHTML"]
const _hoisted_324 = { id: "comp_level_container" }
const _hoisted_325 = ["innerHTML"]
const _hoisted_326 = { id: "comp_l2_column" }
const _hoisted_327 = { id: "comp_l2_row" }
const _hoisted_328 = ["innerHTML"]
const _hoisted_329 = { id: "comp_l2_desc" }
const _hoisted_330 = ["innerHTML"]
const _hoisted_331 = { id: "comp_ini_gapless" }
const _hoisted_332 = { id: "comp_ini_row" }
const _hoisted_333 = { id: "comp_l2_desc" }
const _hoisted_334 = { id: "comp_l2_desc3" }
const _hoisted_335 = { id: "comp_ini_row" }
const _hoisted_336 = { id: "comp_l2_desc" }
const _hoisted_337 = { id: "comp_l2_desc3" }
const _hoisted_338 = { id: "comp_ini_row" }
const _hoisted_339 = { id: "comp_l2_desc" }
const _hoisted_340 = { id: "comp_l2_desc3" }
const _hoisted_341 = { id: "comp_ini_row" }
const _hoisted_342 = { id: "comp_l2_desc" }
const _hoisted_343 = { id: "comp_l2_desc3" }
const _hoisted_344 = { id: "comp_ini_row" }
const _hoisted_345 = { id: "comp_l2_desc" }
const _hoisted_346 = { id: "comp_l2_desc3" }
const _hoisted_347 = { id: "comp_ini_row" }
const _hoisted_348 = { id: "comp_l2_desc" }
const _hoisted_349 = { id: "comp_l2_desc3" }
const _hoisted_350 = { id: "comp_ini_row" }
const _hoisted_351 = { id: "comp_l2_desc" }
const _hoisted_352 = { id: "comp_l2_desc3" }
const _hoisted_353 = { id: "comp_ini_row" }
const _hoisted_354 = { id: "comp_l2_desc" }
const _hoisted_355 = { id: "comp_l2_desc3" }
const _hoisted_356 = { id: "comp_ini_row" }
const _hoisted_357 = { id: "comp_l2_desc" }
const _hoisted_358 = { id: "comp_l2_desc3" }
const _hoisted_359 = { id: "comp_ini_row" }
const _hoisted_360 = { id: "comp_l2_desc" }
const _hoisted_361 = { id: "comp_l2_desc3" }
const _hoisted_362 = { id: "comp_ini_row" }
const _hoisted_363 = { id: "comp_l2_desc" }
const _hoisted_364 = { id: "comp_l2_desc3" }
const _hoisted_365 = { id: "comp_ini_row" }
const _hoisted_366 = { id: "comp_l2_desc" }
const _hoisted_367 = { id: "comp_l2_desc3" }
const _hoisted_368 = { id: "comp_l2_row" }
const _hoisted_369 = { id: "comp_scores_row" }
const _hoisted_370 = { id: "comp_ring" }
const _hoisted_371 = { id: "comp_desc_rows" }
const _hoisted_372 = { id: "comp_scores_title" }
const _hoisted_373 = ["innerHTML"]
const _hoisted_374 = { id: "comp_scores_row" }
const _hoisted_375 = { id: "comp_ring" }
const _hoisted_376 = { id: "comp_desc_rows" }
const _hoisted_377 = { id: "comp_scores_title" }
const _hoisted_378 = ["innerHTML"]
const _hoisted_379 = { id: "comp_scores_row" }
const _hoisted_380 = { id: "comp_ring" }
const _hoisted_381 = { id: "comp_desc_rows" }
const _hoisted_382 = { id: "comp_scores_title" }
const _hoisted_383 = ["innerHTML"]
const _hoisted_384 = { id: "comp_level_container" }
const _hoisted_385 = ["innerHTML"]
const _hoisted_386 = { id: "comp_l3_column" }
const _hoisted_387 = { id: "comp_l3_row" }
const _hoisted_388 = ["innerHTML"]
const _hoisted_389 = { id: "comp_l3_rank-col" }
const _hoisted_390 = { id: "comp_l2_desc" }
const _hoisted_391 = { id: "comp_l3_rank-col" }
const _hoisted_392 = { id: "comp_l2_desc" }
const _hoisted_393 = { id: "comp_l3_rank-col" }
const _hoisted_394 = { id: "comp_l2_desc" }
const _hoisted_395 = { id: "comp_l3_rank-col" }
const _hoisted_396 = { id: "comp_l2_desc" }
const _hoisted_397 = { id: "comp_l3_rank-col" }
const _hoisted_398 = { id: "comp_l2_desc" }
const _hoisted_399 = { id: "comp_l3_rank-col" }
const _hoisted_400 = { id: "comp_l2_desc" }
const _hoisted_401 = { id: "comp_l3_rank-col" }
const _hoisted_402 = { id: "comp_l2_desc" }
const _hoisted_403 = { id: "comp_l3_row" }
const _hoisted_404 = { id: "comp_scores_row" }
const _hoisted_405 = { id: "comp_ring" }
const _hoisted_406 = { id: "comp_desc_rows" }
const _hoisted_407 = { id: "comp_scores_title" }
const _hoisted_408 = ["innerHTML"]
const _hoisted_409 = { id: "comp_scores_row" }
const _hoisted_410 = { id: "comp_ring" }
const _hoisted_411 = { id: "comp_desc_rows" }
const _hoisted_412 = { id: "comp_scores_title" }
const _hoisted_413 = ["innerHTML"]
const _hoisted_414 = { id: "comp_scores_row" }
const _hoisted_415 = { id: "comp_ring" }
const _hoisted_416 = { id: "comp_desc_rows" }
const _hoisted_417 = { id: "comp_scores_title" }
const _hoisted_418 = ["innerHTML"]
const _hoisted_419 = { id: "comp_level_container" }
const _hoisted_420 = ["innerHTML"]
const _hoisted_421 = { id: "comp_l4_column" }
const _hoisted_422 = ["innerHTML"]
const _hoisted_423 = { id: "comp_l4_row2" }
const _hoisted_424 = { id: "comp_tiki_container" }
const _hoisted_425 = {
  key: 0,
  id: "comp_gold_IMG"
}
const _hoisted_426 = {
  key: 1,
  id: "comp_silver_IMG"
}
const _hoisted_427 = {
  key: 2,
  id: "comp_bronze_IMG"
}
const _hoisted_428 = { id: "comp_level_container" }
const _hoisted_429 = ["innerHTML"]
const _hoisted_430 = { id: "comp_l5_column" }
const _hoisted_431 = ["innerHTML"]
const _hoisted_432 = { id: "comp_l5_row" }
const _hoisted_433 = { id: "comp_scores_row" }
const _hoisted_434 = { id: "comp_ring" }
const _hoisted_435 = { id: "comp_desc_row" }
const _hoisted_436 = { id: "comp_scores_title" }
const _hoisted_437 = ["innerHTML"]
const _hoisted_438 = { id: "comp_scores_row" }
const _hoisted_439 = { id: "comp_ring" }
const _hoisted_440 = { id: "comp_desc_row" }
const _hoisted_441 = { id: "comp_scores_title" }
const _hoisted_442 = ["innerHTML"]
const _hoisted_443 = { id: "comp_scores_row" }
const _hoisted_444 = { id: "comp_ring" }
const _hoisted_445 = { id: "comp_desc_row" }
const _hoisted_446 = { id: "comp_scores_title" }
const _hoisted_447 = ["innerHTML"]
const _hoisted_448 = {
  key: 12,
  class: "screen_size",
  id: "animated_screen"
}
const _hoisted_449 = { class: "modal_background" }
const _hoisted_450 = { id: "fail_box" }
const _hoisted_451 = { id: "fail_title" }
const _hoisted_452 = { id: "fail_desc_box" }
const _hoisted_453 = ["innerHTML"]
const _hoisted_454 = { id: "fail_BTN_box" }
const _hoisted_455 = {
  key: 13,
  class: "screen_size",
  id: "animated_screen"
}
const _hoisted_456 = { class: "modal_background" }
const _hoisted_457 = { id: "over_box" }
const _hoisted_458 = { id: "over_title" }
const _hoisted_459 = { id: "over_desc_box" }
const _hoisted_460 = ["innerHTML"]
const _hoisted_461 = { id: "over_BTN_box" }
const _hoisted_462 = { key: 14 }
const _hoisted_463 = ["innerHTML"]
const _hoisted_464 = { class: "tag-container full-screen-cover" }
const _hoisted_465 = { class: "variable-container full-screen-cover" }
const _hoisted_466 = {
  key: 0,
  class: "option-overlay full-screen-cover"
}
const _hoisted_467 = { class: "option-list full-screen-cover" }
const _hoisted_468 = ["innerHTML", "onClick"]
const _hoisted_469 = { class: "button-container full-screen-cover" }
const _hoisted_470 = {
  class: "button",
  method: "post",
  enctype: "multipart/form-data"
}
const _hoisted_471 = { class: "path-text-container full-screen-cover" }
const _hoisted_472 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radial_progress = _resolveComponent("radial-progress")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_tippy = _resolveComponent("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _cache[235] || (_cache[235] = _createElementVNode("div", null, [
          _createElementVNode("div", { class: "splash_container" }, [
            _createElementVNode("div", { id: "geo_logo" }),
            _createElementVNode("div", { id: "waikato_logo" }),
            _createElementVNode("div", { id: "kotahi_logo" })
          ])
        ], -1)),
        (_ctx.tag('screentype') == 'MainMenu')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[73] || (_cache[73] = _createElementVNode("div", { id: "menu_title" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  id: "menu_BTN",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doChoice(0)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1),
                  _cache[72] || (_cache[72] = _createElementVNode("div", { id: "menu_play_icon" }, null, -1))
                ])
              ]),
              _cache[74] || (_cache[74] = _createStaticVNode("<div class=\"menu_images\"><div id=\"menu_rawiri\"></div><div id=\"menu_tribe1\"></div><div id=\"menu_tribe2\"></div></div><div id=\"menu_jasmine\"></div><div id=\"menu_minister\"></div><div id=\"menu_background\"></div>", 4))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'Intro')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h1", {
                id: "intro_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", {
                  id: "intro_box_title",
                  innerHTML: _ctx.tag('header')
                }, null, 8, _hoisted_9),
                _createElementVNode("p", {
                  id: "intro_box_desc",
                  innerHTML: _ctx.tag('description')
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  id: "cont_BTN_style",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doChoice(0)))
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.storyChoices[0]), 1),
                  _cache[75] || (_cache[75] = _createElementVNode("div", { id: "cont_icon" }, null, -1))
                ])
              ]),
              _cache[76] || (_cache[76] = _createElementVNode("div", { id: "intro_char_IMG" }, null, -1)),
              _cache[77] || (_cache[77] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'Intro_StudyParticipation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("h1", {
                id: "intro_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  id: "data_title",
                  innerHTML: _ctx.tag('d1')
                }, null, 8, _hoisted_16),
                _createElementVNode("div", {
                  id: "data_desc",
                  innerHTML: _ctx.tag('description1')
                }, null, 8, _hoisted_17),
                _createElementVNode("div", {
                  id: "data_BTN",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doChoice(0))),
                  innerHTML: _ctx.variable('Btn_DataProtectionStatement')
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  id: "study_title",
                  innerHTML: _ctx.tag('d2')
                }, null, 8, _hoisted_20),
                _createElementVNode("div", {
                  id: "study_desc",
                  innerHTML: _ctx.tag('description2')
                }, null, 8, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  id: "no_BTN",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doChoice(2)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.variable('btn_No')), 1),
                  _cache[78] || (_cache[78] = _createElementVNode("div", { id: "cross_icon" }, null, -1))
                ]),
                _createElementVNode("div", {
                  id: "yes_BTN",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doChoice(1)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.variable('btn_Yes')), 1),
                  _cache[79] || (_cache[79] = _createElementVNode("div", { id: "check_icon" }, null, -1))
                ])
              ]),
              _cache[83] || (_cache[83] = _createElementVNode("div", { id: "intro_char_IMG" }, null, -1)),
              _cache[84] || (_cache[84] = _createElementVNode("div", { id: "default_background" }, null, -1)),
              (_ctx.tag('modal') == 'dataprotection')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", {
                        id: "data_modal_title",
                        innerHTML: _ctx.tag('modalheader')
                      }, null, 8, _hoisted_25),
                      _createElementVNode("div", {
                        id: "data_modal_desc",
                        innerHTML: _ctx.tag('modaldescription')
                      }, null, 8, _hoisted_26),
                      _createElementVNode("div", {
                        id: "data_modal_okay_BTN",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doChoice(0))),
                        innerHTML: _ctx.storyChoices[0]
                      }, null, 8, _hoisted_27),
                      _createElementVNode("div", {
                        id: "data_modal_close_BTN",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doChoice(0)))
                      }, [...(_cache[80] || (_cache[80] = [
                        _createElementVNode("div", { id: "cross_icon" }, null, -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tag('modal') == 'participationconfirmation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        id: "study_modal_title",
                        innerHTML: _ctx.tag('modalheader')
                      }, null, 8, _hoisted_30),
                      _createElementVNode("div", {
                        id: "study_modal_desc",
                        innerHTML: _ctx.tag('modaldescription')
                      }, null, 8, _hoisted_31),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", {
                          id: "study_modal_return_BTN",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doChoice(0)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1),
                          _cache[81] || (_cache[81] = _createElementVNode("div", { id: "arrow_left_icon" }, null, -1))
                        ]),
                        _createElementVNode("div", {
                          id: "study_modal_cancel_BTN",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doChoice(1)))
                        }, _toDisplayString(_ctx.storyChoices[1]), 1)
                      ]),
                      _createElementVNode("div", {
                        id: "data_modal_close_BTN",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doChoice(1)))
                      }, [...(_cache[82] || (_cache[82] = [
                        _createElementVNode("div", { id: "cross_icon" }, null, -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'Intro_NameInput')
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("h1", {
                id: "intro_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_34),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", {
                  id: "name_title",
                  innerHTML: _ctx.tag('header')
                }, null, 8, _hoisted_36),
                _withDirectives(_createElementVNode("input", {
                  id: "name_input_box",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.playerName) = $event)),
                  placeholder: "Enter Name Here"
                }, null, 512), [
                  [_vModelText, _ctx.playerName]
                ])
              ]),
              (_ctx.playerName.length >= 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", {
                      id: "cont_BTN_style",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.doChoice(0)))
                    }, [
                      _createElementVNode("div", {
                        id: "cont_BTN",
                        innerHTML: _ctx.storyChoices[0]
                      }, null, 8, _hoisted_38),
                      _cache[85] || (_cache[85] = _createElementVNode("div", { id: "cont_icon" }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[86] || (_cache[86] = _createElementVNode("div", { id: "intro_char_IMG" }, null, -1)),
              _cache[87] || (_cache[87] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'ScenarioSelect')
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", {
                id: "scene_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_40),
              _createElementVNode("div", {
                id: "scene_desc",
                innerHTML: _ctx.tag('description')
              }, null, 8, _hoisted_41),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _cache[89] || (_cache[89] = _createElementVNode("div", { id: "card_IMG" }, [
                      _createElementVNode("div", { id: "fungus_IMG" })
                    ], -1)),
                    _createElementVNode("div", {
                      id: "card_title",
                      innerHTML: _ctx.tag('header1')
                    }, null, 8, _hoisted_45),
                    _createElementVNode("div", {
                      id: "card_desc",
                      innerHTML: _ctx.tag('description1')
                    }, null, 8, _hoisted_46),
                    _createElementVNode("div", {
                      id: "card_BTN",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectScenario(1)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1),
                      _cache[88] || (_cache[88] = _createElementVNode("div", { id: "cont_icon" }, null, -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[91] || (_cache[91] = _createElementVNode("div", { id: "card_IMG" }, [
                      _createElementVNode("div", { id: "seaweed_IMG" })
                    ], -1)),
                    _createElementVNode("div", {
                      id: "card_title",
                      innerHTML: _ctx.tag('header2')
                    }, null, 8, _hoisted_50),
                    _createElementVNode("div", {
                      id: "card_desc",
                      innerHTML: _ctx.tag('description2')
                    }, null, 8, _hoisted_51),
                    _createElementVNode("div", {
                      id: "card_BTN",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectScenario(2)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[1]), 1),
                      _cache[90] || (_cache[90] = _createElementVNode("div", { id: "cont_icon" }, null, -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[93] || (_cache[93] = _createElementVNode("div", { id: "card_IMG" }, [
                      _createElementVNode("div", { id: "kawakawa_IMG" })
                    ], -1)),
                    _createElementVNode("div", {
                      id: "card_title",
                      innerHTML: _ctx.tag('header3')
                    }, null, 8, _hoisted_55),
                    _createElementVNode("div", {
                      id: "card_desc",
                      innerHTML: _ctx.tag('description3')
                    }, null, 8, _hoisted_56),
                    _createElementVNode("div", {
                      id: "card_BTN",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectScenario(3)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[2]), 1),
                      _cache[92] || (_cache[92] = _createElementVNode("div", { id: "cont_icon" }, null, -1))
                    ])
                  ])
                ])
              ]),
              _cache[94] || (_cache[94] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'Dialogue')
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_radial_progress, {
                    diameter: 75,
                    "stroke-width": 6,
                    "inner-stroke-width": 6,
                    "inner-stroke-color": '#FFFFFF',
                    "completed-steps": _ctx.intVariable('RelationshipScore'),
                    "total-steps": _ctx.intVariable('RelationshipRingMax'),
                    "start-color": '#B23256',
                    "stop-color": '#B23256',
                    "animate-speed": 800,
                    "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                  }, {
                    default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                      _createElementVNode("div", { id: "rela_IMG" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["completed-steps", "total-steps"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_radial_progress, {
                    diameter: 75,
                    "stroke-width": 6,
                    "inner-stroke-width": 6,
                    "inner-stroke-color": '#FFFFFF',
                    "completed-steps": _ctx.intVariable('FairnessScore'),
                    "total-steps": _ctx.intVariable('FairnessRingMax'),
                    "start-color": '#3247B2',
                    "stop-color": '#3247B2',
                    "animate-speed": 800,
                    "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                  }, {
                    default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                      _createElementVNode("div", { id: "fair_IMG" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["completed-steps", "total-steps"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_radial_progress, {
                    diameter: 75,
                    "stroke-width": 6,
                    "inner-stroke-width": 6,
                    "inner-stroke-color": '#FFFFFF',
                    "completed-steps": _ctx.intVariable('EquityScore'),
                    "total-steps": _ctx.intVariable('EquityRingMax'),
                    "start-color": '#32B285',
                    "stop-color": '#32B285',
                    "animate-speed": 800,
                    "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                  }, {
                    default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                      _createElementVNode("div", { id: "equit_IMG" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["completed-steps", "total-steps"])
                ])
              ]),
              _createElementVNode("div", {
                id: "speaker_box",
                innerHTML: _ctx.storyText
              }, null, 8, _hoisted_62),
              (_ctx.tag('speaker') != 'Exposition')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      id: "speaker_name",
                      innerHTML: _ctx.friendlyName
                    }, null, 8, _hoisted_63),
                    _createElementVNode("div", {
                      id: "speaker_title",
                      innerHTML: _ctx.description
                    }, null, 8, _hoisted_64)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_65, [
                (_ctx.tag('speaker') == 'TribalLeaders')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66))
                  : _createCommentVNode("", true),
                (_ctx.tag('speaker') == 'Rawiri')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67))
                  : _createCommentVNode("", true),
                (_ctx.tag('speaker') == 'MinisterLong')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68))
                  : _createCommentVNode("", true),
                (_ctx.tag('speaker') == 'JasmineStrong')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                  : _createCommentVNode("", true),
                (_ctx.tag('speaker') == 'TribalLeader2')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                id: "dialogue_title_box",
                innerHTML: _ctx.tag('levelTitle')
              }, null, 8, _hoisted_71),
              _createElementVNode("div", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyChoices, (choice, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'choice' + index,
                    id: "encompassing_dialogue_box",
                    onClick: ($event: any) => (_ctx.doChoice(index))
                  }, [
                    _createElementVNode("div", {
                      id: "dialogue_title",
                      innerHTML: _ctx.choiceHeader(index)
                    }, null, 8, _hoisted_74),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", {
                        id: "dialogue_box",
                        innerHTML: _ctx.choiceDescription(index)
                      }, null, 8, _hoisted_76),
                      (_ctx.tag('context') == (index + 1 + ''))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_73))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_78, [
                (_ctx.storyChoices.length == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "cont_BTN_style",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.doContinue()))
                    }, [...(_cache[98] || (_cache[98] = [
                      _createElementVNode("div", { id: "cont_BTN" }, "Continue", -1),
                      _createElementVNode("div", { id: "cont_icon" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.tag('location') == 'MeetingHouse')
                ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                : _createCommentVNode("", true),
              (_ctx.tag('location') == 'GovernmentOffice')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                : _createCommentVNode("", true),
              (_ctx.tag('location') == 'CorporateBoardroom')
                ? (_openBlock(), _createElementBlock("div", _hoisted_81))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'BudgetSlider')
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
              _createElementVNode("div", {
                id: "budget_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_83),
              _createElementVNode("div", {
                id: "budget_desc",
                innerHTML: _ctx.tag('header')
              }, null, 8, _hoisted_84),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", {
                  id: "cont_BTN_style",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.doChoice('Confirm Budget')))
                }, [...(_cache[99] || (_cache[99] = [
                  _createElementVNode("div", { id: "cont_BTN" }, "Confirm", -1),
                  _createElementVNode("div", { id: "check_icon" }, null, -1)
                ]))])
              ]),
              _cache[101] || (_cache[101] = _createElementVNode("div", { id: "default_background" }, null, -1)),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, " $" + _toDisplayString(_ctx.formatNumber(_ctx.getNumberVariable('ScenarioBudgetAssigned'))), 1),
                _cache[100] || (_cache[100] = _createElementVNode("div", { id: "slider_title" }, "Your annual budget will be", -1)),
                _createElementVNode("div", _hoisted_88, "Percentage of Total Budget: " + _toDisplayString((_ctx.scenarioBudgetAssigned * 100) / _ctx.intVariable('ScenarioBudget')) + "%", 1),
                _createVNode(_component_vue_slider, {
                  max: _ctx.intVariable('ScenarioBudget'),
                  interval: 5000,
                  zoom: _ctx.zoom,
                  class: "budget-slider",
                  width: "612px",
                  height: "32px",
                  modelValue: _ctx.scenarioBudgetAssigned,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.scenarioBudgetAssigned) = $event))
                }, null, 8, ["max", "zoom", "modelValue"])
              ]),
              (_ctx.tag('modal') == 'notenoughbudget')
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.tag('modalheader')), 1),
                      _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.tag('modaldescription')), 1),
                      _createElementVNode("div", {
                        id: "budget_okay_BTN",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.doChoice(0))),
                        innerHTML: _ctx.storyChoices[0]
                      }, null, 8, _hoisted_93)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'BudgetAllocation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
              _createElementVNode("div", {
                id: "allocation_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_95),
              _createElementVNode("div", {
                id: "allocation_description",
                innerHTML: _ctx.tag('description')
              }, null, 8, _hoisted_96),
              _cache[169] || (_cache[169] = _createStaticVNode("<div id=\"alloc_background_lines_box\"><div id=\"alloc_top_line\"></div><div id=\"alloc_middle_line\"></div><div id=\"alloc_bottom_line\"></div><div id=\"alloc_vertical_line\"></div></div>", 1)),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _cache[102] || (_cache[102] = _createElementVNode("div", { id: "schol_icon" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.tag('header1')), 1)
                  ]),
                  _createElementVNode("div", {
                    id: "type_desc",
                    innerHTML: _ctx.tag('description1')
                  }, null, 8, _hoisted_100)
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("div", _hoisted_102, [
                    _cache[103] || (_cache[103] = _createElementVNode("div", { id: "comm_icon" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.tag('header2')), 1)
                  ]),
                  _createElementVNode("div", {
                    id: "type_desc",
                    innerHTML: _ctx.tag('description2')
                  }, null, 8, _hoisted_103)
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _cache[104] || (_cache[104] = _createElementVNode("div", { id: "indi_icon" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.tag('header3')), 1)
                  ]),
                  _createElementVNode("div", {
                    id: "type_desc",
                    innerHTML: _ctx.tag('description3')
                  }, null, 8, _hoisted_106)
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget1.5')
                  }, null, 8, _hoisted_108),
                  _cache[109] || (_cache[109] = _createElementVNode("div", { id: "adds_cost" }, "$5k", -1)),
                  (_ctx.intVariable('student'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('Student') / 5000
                      }, null, 8, _hoisted_109))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_110, [
                    (_ctx.intVariable('student') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.doChoice(1)))
                        }, [...(_cache[105] || (_cache[105] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('student') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [...(_cache[106] || (_cache[106] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 5000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.doChoice(0)))
                        }, [...(_cache[107] || (_cache[107] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 5000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [...(_cache[108] || (_cache[108] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget1')
                  }, null, 8, _hoisted_114),
                  _cache[114] || (_cache[114] = _createElementVNode("div", { id: "adds_cost" }, "$10k", -1)),
                  (_ctx.intVariable('intern'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('Intern') / 10000
                      }, null, 8, _hoisted_115))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_116, [
                    (_ctx.intVariable('intern') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.doChoice(3)))
                        }, [...(_cache[110] || (_cache[110] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('intern') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [...(_cache[111] || (_cache[111] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 10000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.doChoice(2)))
                        }, [...(_cache[112] || (_cache[112] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 10000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [...(_cache[113] || (_cache[113] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget2')
                  }, null, 8, _hoisted_120),
                  _cache[119] || (_cache[119] = _createElementVNode("div", { id: "adds_cost" }, "$20k", -1)),
                  (_ctx.intVariable('Masters'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('Masters') / 20000
                      }, null, 8, _hoisted_121))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_122, [
                    (_ctx.intVariable('Masters') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.doChoice(5)))
                        }, [...(_cache[115] || (_cache[115] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('Masters') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [...(_cache[116] || (_cache[116] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 20000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.doChoice(4)))
                        }, [...(_cache[117] || (_cache[117] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 20000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [...(_cache[118] || (_cache[118] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget3')
                  }, null, 8, _hoisted_126),
                  _cache[124] || (_cache[124] = _createElementVNode("div", { id: "adds_cost" }, "$40k", -1)),
                  (_ctx.intVariable('PhD'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('PhD') / 40000
                      }, null, 8, _hoisted_127))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_128, [
                    (_ctx.intVariable('PhD') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.doChoice(7)))
                        }, [...(_cache[120] || (_cache[120] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('PhD') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_129, [...(_cache[121] || (_cache[121] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 40000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.doChoice(6)))
                        }, [...(_cache[122] || (_cache[122] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 40000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_130, [...(_cache[123] || (_cache[123] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget4.5')
                  }, null, 8, _hoisted_132),
                  _cache[129] || (_cache[129] = _createElementVNode("div", { id: "adds_cost" }, "$2.5k", -1)),
                  (_ctx.intVariable('CommunityMeeting'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('CommunityMeeting') / 2500
                      }, null, 8, _hoisted_133))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_134, [
                    (_ctx.intVariable('CommunityMeeting') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.doChoice(9)))
                        }, [...(_cache[125] || (_cache[125] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('CommunityMeeting') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [...(_cache[126] || (_cache[126] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 2500)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.doChoice(8)))
                        }, [...(_cache[127] || (_cache[127] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 2500)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [...(_cache[128] || (_cache[128] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget4')
                  }, null, 8, _hoisted_138),
                  _cache[134] || (_cache[134] = _createElementVNode("div", { id: "adds_cost" }, "$5k", -1)),
                  (_ctx.intVariable('SmallWorkshop'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('SmallWorkshop') / 5000
                      }, null, 8, _hoisted_139))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_140, [
                    (_ctx.intVariable('smallworkshop') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.doChoice(11)))
                        }, [...(_cache[130] || (_cache[130] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('smallworkshop') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_141, [...(_cache[131] || (_cache[131] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 5000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.doChoice(10)))
                        }, [...(_cache[132] || (_cache[132] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 5000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_142, [...(_cache[133] || (_cache[133] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget5')
                  }, null, 8, _hoisted_144),
                  _cache[139] || (_cache[139] = _createElementVNode("div", { id: "adds_cost" }, "$10k", -1)),
                  (_ctx.intVariable('CommunityEvent'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('CommunityEvent') / 10000
                      }, null, 8, _hoisted_145))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_146, [
                    (_ctx.intVariable('communityevent') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.doChoice(13)))
                        }, [...(_cache[135] || (_cache[135] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('communityevent') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [...(_cache[136] || (_cache[136] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 10000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.doChoice(12)))
                        }, [...(_cache[137] || (_cache[137] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 10000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_148, [...(_cache[138] || (_cache[138] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget6')
                  }, null, 8, _hoisted_150),
                  _cache[144] || (_cache[144] = _createElementVNode("div", { id: "adds_cost" }, "$20k", -1)),
                  (_ctx.intVariable('CapacityBuildingProgram'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('CapacityBuildingProgram') / 20000
                      }, null, 8, _hoisted_151))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_152, [
                    (_ctx.intVariable('CapacityBuildingProgram') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.doChoice(15)))
                        }, [...(_cache[140] || (_cache[140] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('CapacityBuildingProgram') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, [...(_cache[141] || (_cache[141] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 20000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.doChoice(14)))
                        }, [...(_cache[142] || (_cache[142] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 20000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_154, [...(_cache[143] || (_cache[143] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_155, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget7.5')
                  }, null, 8, _hoisted_156),
                  _cache[149] || (_cache[149] = _createElementVNode("div", { id: "adds_cost" }, "$10k", -1)),
                  (_ctx.intVariable('CommunityAdvisoryGroup'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('CommunityAdvisoryGroup') / 10000
                      }, null, 8, _hoisted_157))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_158, [
                    (_ctx.intVariable('CommunityAdvisoryGroup') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.doChoice(17)))
                        }, [...(_cache[145] || (_cache[145] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('CommunityAdvisoryGroup') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_159, [...(_cache[146] || (_cache[146] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 10000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.doChoice(16)))
                        }, [...(_cache[147] || (_cache[147] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 10000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_160, [...(_cache[148] || (_cache[148] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_161, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget7')
                  }, null, 8, _hoisted_162),
                  _cache[154] || (_cache[154] = _createElementVNode("div", { id: "adds_cost" }, "$20k", -1)),
                  (_ctx.intVariable('Consultant'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('Consultant') / 20000
                      }, null, 8, _hoisted_163))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_164, [
                    (_ctx.intVariable('consultant') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.doChoice(19)))
                        }, [...(_cache[150] || (_cache[150] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('consultant') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [...(_cache[151] || (_cache[151] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 20000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.doChoice(18)))
                        }, [...(_cache[152] || (_cache[152] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 20000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_166, [...(_cache[153] || (_cache[153] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget8')
                  }, null, 8, _hoisted_168),
                  _cache[159] || (_cache[159] = _createElementVNode("div", { id: "adds_cost" }, "$40k", -1)),
                  (_ctx.intVariable('PartTimeResearcher'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('PartTimeResearcher') / 40000
                      }, null, 8, _hoisted_169))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_170, [
                    (_ctx.intVariable('PartTimeResearcher') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.doChoice(21)))
                        }, [...(_cache[155] || (_cache[155] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('PartTimeResearcher') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_171, [...(_cache[156] || (_cache[156] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 40000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.doChoice(20)))
                        }, [...(_cache[157] || (_cache[157] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 40000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_172, [...(_cache[158] || (_cache[158] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_173, [
                  _createElementVNode("div", {
                    id: "adds_title",
                    innerHTML: _ctx.tag('budget9')
                  }, null, 8, _hoisted_174),
                  _cache[164] || (_cache[164] = _createElementVNode("div", { id: "adds_cost" }, "$80k", -1)),
                  (_ctx.intVariable('FullTimeResearcher'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "adds_amount",
                        innerHTML: _ctx.intVariable('FullTimeResearcher') / 80000
                      }, null, 8, _hoisted_175))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_176, [
                    (_ctx.intVariable('FullTimeResearcher') >= 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "adds_sub_BTN",
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.doChoice(23)))
                        }, [...(_cache[160] || (_cache[160] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') == _ctx.intVariable('totalBudget') || _ctx.intVariable('FullTimeResearcher') < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_177, [...(_cache[161] || (_cache[161] = [
                          _createElementVNode("div", { id: "sub_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') >= 80000)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          id: "adds_add_BTN",
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.doChoice(22)))
                        }, [...(_cache[162] || (_cache[162] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.intVariable('scenariobudget') < 80000)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_178, [...(_cache[163] || (_cache[163] = [
                          _createElementVNode("div", { id: "add_icon" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("div", {
                      id: "remain_title",
                      innerHTML: _ctx.tag('header')
                    }, null, 8, _hoisted_181),
                    _createElementVNode("div", _hoisted_182, "$" + _toDisplayString(_ctx.formatNumber(_ctx.intVariable('scenariobudget'))), 1),
                    _createElementVNode("div", _hoisted_183, "/$" + _toDisplayString(_ctx.formatNumber(_ctx.intVariable('totalBudget'))), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_184, [
                _createElementVNode("div", {
                  id: "cont_BTN_style",
                  onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.doChoice(24)))
                }, [...(_cache[165] || (_cache[165] = [
                  _createElementVNode("div", { id: "cont_BTN" }, "Continue", -1),
                  _createElementVNode("div", { id: "cont_icon" }, null, -1)
                ]))])
              ]),
              (_ctx.tag('modal') == 'confirmfunding')
                ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                    _createElementVNode("div", _hoisted_186, [
                      _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.tag('modalheader')), 1),
                      _createElementVNode("div", _hoisted_188, _toDisplayString(_ctx.tag('modaldescription')), 1),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", {
                          id: "study_modal_return_BTN",
                          onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.doChoice(1)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.storyChoices[1]), 1),
                          _cache[166] || (_cache[166] = _createElementVNode("div", { id: "check_icon" }, null, -1))
                        ]),
                        _createElementVNode("div", {
                          id: "study_modal_cancel_BTN",
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.doChoice(0)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1),
                          _cache[167] || (_cache[167] = _createElementVNode("div", { id: "cross_icon" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", {
                        id: "data_modal_close_BTN",
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.doChoice(0)))
                      }, [...(_cache[168] || (_cache[168] = [
                        _createElementVNode("div", { id: "cross_icon" }, null, -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[170] || (_cache[170] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'SurveyDefinitions')
          ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
              _createElementVNode("div", {
                id: "survey_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_191),
              _createElementVNode("div", {
                id: "survey_intro_desc",
                innerHTML: _ctx.storyText
              }, null, 8, _hoisted_192),
              _createElementVNode("div", _hoisted_193, [
                _createElementVNode("div", _hoisted_194, [
                  _createElementVNode("div", {
                    id: "survey_def_header",
                    innerHTML: _ctx.tag('title0')
                  }, null, 8, _hoisted_195),
                  _createElementVNode("div", {
                    id: "survey_def_header2",
                    innerHTML: _ctx.tag('desc0')
                  }, null, 8, _hoisted_196)
                ]),
                _createElementVNode("div", _hoisted_197, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title1')
                  }, null, 8, _hoisted_198),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc1')
                  }, null, 8, _hoisted_199)
                ]),
                _createElementVNode("div", _hoisted_200, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title2')
                  }, null, 8, _hoisted_201),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc2')
                  }, null, 8, _hoisted_202)
                ]),
                _createElementVNode("div", _hoisted_203, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title3')
                  }, null, 8, _hoisted_204),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc3')
                  }, null, 8, _hoisted_205)
                ]),
                _createElementVNode("div", _hoisted_206, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title4')
                  }, null, 8, _hoisted_207),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc4')
                  }, null, 8, _hoisted_208)
                ]),
                _createElementVNode("div", _hoisted_209, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title5')
                  }, null, 8, _hoisted_210),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc5')
                  }, null, 8, _hoisted_211)
                ]),
                _createElementVNode("div", _hoisted_212, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title6')
                  }, null, 8, _hoisted_213),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc6')
                  }, null, 8, _hoisted_214)
                ]),
                _createElementVNode("div", _hoisted_215, [
                  _createElementVNode("div", {
                    id: "survey_def_title",
                    innerHTML: _ctx.tag('title7')
                  }, null, 8, _hoisted_216),
                  _createElementVNode("div", {
                    id: "survey_def_desc",
                    innerHTML: _ctx.tag('desc7')
                  }, null, 8, _hoisted_217)
                ])
              ]),
              _createElementVNode("div", _hoisted_218, [
                (_ctx.storyChoices.length == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "cont_BTN_style",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.doContinue()))
                    }, [...(_cache[171] || (_cache[171] = [
                      _createElementVNode("div", { id: "cont_BTN" }, "Continue", -1),
                      _createElementVNode("div", { id: "cont_icon" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _cache[172] || (_cache[172] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'SurveyChoices')
          ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
              _createElementVNode("div", {
                id: "survey_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_220),
              _cache[175] || (_cache[175] = _createElementVNode("div", { id: "speaker_placement" }, [
                _createElementVNode("div", { id: "jas_IMG" })
              ], -1)),
              (_openBlock(), _createElementBlock("div", {
                id: "survey_choices_group",
                key: 'SurveyContainer' + _ctx.surveyNextClicked,
                class: _normalizeClass({ 'animated': _ctx.surveyNextClicked })
              }, [
                _createElementVNode("div", {
                  id: "least_title",
                  innerHTML: _ctx.tag('least')
                }, null, 8, _hoisted_221),
                _createElementVNode("div", {
                  id: "most_title",
                  innerHTML: _ctx.tag('most')
                }, null, 8, _hoisted_222),
                _createElementVNode("div", {
                  id: "question_title",
                  innerHTML: _ctx.tag('quest')
                }, null, 8, _hoisted_223),
                _createElementVNode("div", _hoisted_224, [
                  _createElementVNode("div", _hoisted_225, [
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_left",
                      type: "radio",
                      name: "leastchoice",
                      value: _ctx.variable('Option1'),
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.leastValue) = $event)),
                      onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.doChoice(0)))
                    }, null, 8, _hoisted_226), [
                      [_vModelRadio, _ctx.leastValue]
                    ]),
                    _createVNode(_component_tippy, {
                      content: _ctx.variable('Description1'),
                      arrow: false,
                      maxWidth: 384,
                      placement: 'top',
                      offset: [0, 12],
                      "follow-cursor": 'horizontal',
                      id: "survey_choice_title"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.variable('Option1')), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_right",
                      type: "radio",
                      name: "mostchoice",
                      value: _ctx.variable('Option1'),
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.mostValue) = $event)),
                      onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.doChoice(3)))
                    }, null, 8, _hoisted_227), [
                      [_vModelRadio, _ctx.mostValue]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_228, [
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_left",
                      type: "radio",
                      name: "leastchoice",
                      value: _ctx.variable('Option2'),
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.leastValue) = $event)),
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.doChoice(1)))
                    }, null, 8, _hoisted_229), [
                      [_vModelRadio, _ctx.leastValue]
                    ]),
                    _createVNode(_component_tippy, {
                      content: _ctx.variable('Description2'),
                      arrow: false,
                      maxWidth: 384,
                      placement: 'top',
                      offset: [0, 12],
                      "follow-cursor": 'horizontal',
                      id: "survey_choice_title"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.variable('Option2')), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_right",
                      type: "radio",
                      name: "mostchoice",
                      value: _ctx.variable('Option2'),
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.mostValue) = $event)),
                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.doChoice(4)))
                    }, null, 8, _hoisted_230), [
                      [_vModelRadio, _ctx.mostValue]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_231, [
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_left",
                      type: "radio",
                      name: "leastchoice",
                      value: _ctx.variable('Option3'),
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.leastValue) = $event)),
                      onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.doChoice(2)))
                    }, null, 8, _hoisted_232), [
                      [_vModelRadio, _ctx.leastValue]
                    ]),
                    _createVNode(_component_tippy, {
                      content: _ctx.variable('Description3'),
                      arrow: false,
                      maxWidth: 384,
                      placement: 'top',
                      offset: [0, 12],
                      "follow-cursor": 'horizontal',
                      id: "survey_choice_title"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.variable('Option3')), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _withDirectives(_createElementVNode("input", {
                      id: "radio_right",
                      type: "radio",
                      name: "mostchoice",
                      value: _ctx.variable('Option3'),
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.mostValue) = $event)),
                      onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.doChoice(5)))
                    }, null, 8, _hoisted_233), [
                      [_vModelRadio, _ctx.mostValue]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_234, [
                  (_ctx.radioNextDisabled == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "next_BTN_style",
                        onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.surveyNext && _ctx.surveyNext(...args)))
                      }, [...(_cache[173] || (_cache[173] = [
                        _createElementVNode("div", { id: "next_BTN" }, "Next", -1),
                        _createElementVNode("div", { id: "arrow_down_icon" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.radioNextDisabled == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_235, [...(_cache[174] || (_cache[174] = [
                        _createElementVNode("div", { id: "next_BTN" }, "Next", -1),
                        _createElementVNode("div", { id: "arrow_down_icon" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ], 2)),
              _cache[176] || (_cache[176] = _createElementVNode("div", { id: "board_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'StageComplete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
              _createElementVNode("div", {
                id: "stage_title",
                innerHTML: _ctx.tag('title')
              }, null, 8, _hoisted_237),
              (_ctx.tag('completiontype') != 'Stage3' && _ctx.tag('completiontype') != 'SLOTeval')
                ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                    (_ctx.tag('completiontype') != 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "stage_result_title",
                          innerHTML: _ctx.tag('header')
                        }, null, 8, _hoisted_239))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') != 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                          _createElementVNode("div", _hoisted_241, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('RelationshipScore'),
                              "total-steps": _ctx.intVariable('RelationshipRingMax'),
                              "start-color": '#b23256',
                              "stop-color": '#b23256',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                                _createElementVNode("div", { id: "stage_rela_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_rela_desc",
                            innerHTML: _ctx.tag('desc1')
                          }, null, 8, _hoisted_242)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') != 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                          _createElementVNode("div", _hoisted_244, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('FairnessScore'),
                              "total-steps": _ctx.intVariable('FairnessRingMax'),
                              "start-color": '#3247b2',
                              "stop-color": '#3247b2',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                                _createElementVNode("div", { id: "stage_fair_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_fair_desc",
                            innerHTML: _ctx.tag('desc2')
                          }, null, 8, _hoisted_245)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') != 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                          _createElementVNode("div", _hoisted_247, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('EquityScore'),
                              "total-steps": _ctx.intVariable('EquityRingMax'),
                              "start-color": '#32b285',
                              "stop-color": '#32b285',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[179] || (_cache[179] = [
                                _createElementVNode("div", { id: "stage_equit_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_equit_desc",
                            innerHTML: _ctx.tag('desc3')
                          }, null, 8, _hoisted_248)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tag('completiontype') == 'Stage3')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    id: "survey_result_desc",
                    innerHTML: _ctx.tag('description')
                  }, null, 8, _hoisted_249))
                : _createCommentVNode("", true),
              (_ctx.tag('completiontype') == 'Stage3')
                ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                    _createElementVNode("div", _hoisted_251, [
                      _createElementVNode("div", _hoisted_252, [
                        _cache[180] || (_cache[180] = _createElementVNode("div", { id: "survey_rank_number" }, "1", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[0].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[0].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_253, [
                        _cache[181] || (_cache[181] = _createElementVNode("div", { id: "survey_rank_number" }, "2", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[1].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[1].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_254, [
                        _cache[182] || (_cache[182] = _createElementVNode("div", { id: "survey_rank_number" }, "3", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[2].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[2].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_255, [
                        _cache[183] || (_cache[183] = _createElementVNode("div", { id: "survey_rank_number" }, "4", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[3].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[3].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_256, [
                        _cache[184] || (_cache[184] = _createElementVNode("div", { id: "survey_rank_number" }, "5", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[4].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[4].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_257, [
                        _cache[185] || (_cache[185] = _createElementVNode("div", { id: "survey_rank_number" }, "6", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[5].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[5].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_258, [
                        _cache[186] || (_cache[186] = _createElementVNode("div", { id: "survey_rank_number" }, "7", -1)),
                        _createVNode(_component_tippy, {
                          content: _ctx.getAllScores()[6].definition,
                          arrow: false,
                          "max-width": 384,
                          placement: 'top',
                          offset: [0, 12],
                          "follow-cursor": 'horizontal',
                          id: "survey_rank_desc"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAllScores()[6].priority), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ])
                    ]),
                    _createElementVNode("div", {
                      id: "rank_most_title",
                      innerHTML: _ctx.tag('header1')
                    }, null, 8, _hoisted_259)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tag('completiontype') == 'Stage3')
                ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                    (_ctx.tag('completiontype') == 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "stage_result_title",
                          innerHTML: _ctx.tag('header')
                        }, null, 8, _hoisted_261))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') == 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                          _createElementVNode("div", _hoisted_263, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('RelationshipScore'),
                              "total-steps": _ctx.intVariable('RelationshipRingMax'),
                              "start-color": '#b23256',
                              "stop-color": '#b23256',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[187] || (_cache[187] = [
                                _createElementVNode("div", { id: "stage_rela_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_rela_desc",
                            innerHTML: _ctx.tag('desc1')
                          }, null, 8, _hoisted_264)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') == 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                          _createElementVNode("div", _hoisted_266, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('FairnessScore'),
                              "total-steps": _ctx.intVariable('FairnessRingMax'),
                              "start-color": '#3247b2',
                              "stop-color": '#3247b2',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[188] || (_cache[188] = [
                                _createElementVNode("div", { id: "stage_fair_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_fair_desc",
                            innerHTML: _ctx.tag('desc2')
                          }, null, 8, _hoisted_267)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tag('completiontype') == 'Stage3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                          _createElementVNode("div", _hoisted_269, [
                            _createVNode(_component_radial_progress, {
                              diameter: 110,
                              "stroke-width": 9,
                              "inner-stroke-width": 9,
                              "inner-stroke-color": '#FFFFFF',
                              "completed-steps": _ctx.placeVariable('EquityScore'),
                              "total-steps": _ctx.intVariable('EquityRingMax'),
                              "start-color": '#32b285',
                              "stop-color": '#32b285',
                              "animate-speed": 800,
                              "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                            }, {
                              default: _withCtx(() => [...(_cache[189] || (_cache[189] = [
                                _createElementVNode("div", { id: "stage_equit_IMG" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["completed-steps", "total-steps"])
                          ]),
                          _createElementVNode("div", {
                            id: "stage_equit_desc",
                            innerHTML: _ctx.tag('desc3')
                          }, null, 8, _hoisted_270)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tag('completiontype') == 'SLOTeval')
                ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                    _createElementVNode("div", _hoisted_272, [
                      _createElementVNode("div", {
                        id: "stage_text_title",
                        innerHTML: _ctx.tag('header')
                      }, null, 8, _hoisted_273),
                      _createElementVNode("div", {
                        id: "stage_text_desc",
                        innerHTML: _ctx.tag('description')
                      }, null, 8, _hoisted_274)
                    ]),
                    _createElementVNode("div", _hoisted_275, [
                      (_ctx.tag('tiki') == 'Silver')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_276))
                        : _createCommentVNode("", true),
                      (_ctx.tag('tiki') == 'Gold')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_277))
                        : _createCommentVNode("", true),
                      (_ctx.tag('tiki') == 'Bronze')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_278))
                        : (_openBlock(), _createElementBlock("div", _hoisted_279))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tag('completiontype') == 'Stage4')
                ? (_openBlock(), _createElementBlock("div", _hoisted_280))
                : _createCommentVNode("", true),
              _cache[191] || (_cache[191] = _createElementVNode("div", { id: "default_background" }, null, -1)),
              _createElementVNode("div", _hoisted_281, [
                _createElementVNode("div", {
                  id: "cont_BTN_style",
                  onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.doChoice(0)))
                }, [
                  _createElementVNode("div", {
                    id: "cont_BTN",
                    innerHTML: _ctx.storyChoices[0]
                  }, null, 8, _hoisted_282),
                  _cache[190] || (_cache[190] = _createElementVNode("div", { id: "check_icon" }, null, -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'Complete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
              _createElementVNode("div", _hoisted_284, [
                _createElementVNode("div", {
                  id: "overall_title",
                  innerHTML: _ctx.tag('title')
                }, null, 8, _hoisted_285),
                _createElementVNode("div", {
                  id: "overall_desc",
                  innerHTML: _ctx.tag('description')
                }, null, 8, _hoisted_286),
                _createElementVNode("div", {
                  id: "overall_tiki_title",
                  innerHTML: _ctx.tag('header1')
                }, null, 8, _hoisted_287),
                _createElementVNode("div", _hoisted_288, [
                  (_ctx.tag('PlayerTikiAward') == 'Gold')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_289))
                    : _createCommentVNode("", true),
                  (_ctx.tag('PlayerTikiAward') == 'Silver')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_290))
                    : _createCommentVNode("", true),
                  (_ctx.tag('PlayerTikiAward') == 'Bronze')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_291))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    id: "overall_tiki_desc",
                    innerHTML: _ctx.tag('PlayerTikiAward')
                  }, null, 8, _hoisted_292)
                ]),
                _createElementVNode("div", {
                  id: "overall_score_title",
                  innerHTML: _ctx.tag('header2')
                }, null, 8, _hoisted_293),
                _createElementVNode("div", _hoisted_294, [
                  _createElementVNode("div", _hoisted_295, [
                    _createElementVNode("div", _hoisted_296, [
                      _createVNode(_component_radial_progress, {
                        diameter: 80,
                        "stroke-width": 8,
                        "inner-stroke-width": 8,
                        "inner-stroke-color": '#FFFFFF',
                        "completed-steps": _ctx.placeVariable('TotalRelationshipScore'),
                        "total-steps": _ctx.placeVariable('TotalRelationshipMax'),
                        "start-color": '#b23256',
                        "stop-color": '#b23256',
                        "animate-speed": 800,
                        "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                      }, {
                        default: _withCtx(() => [...(_cache[192] || (_cache[192] = [
                          _createElementVNode("div", { id: "overall_rela_IMG" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["completed-steps", "total-steps"])
                    ]),
                    _createElementVNode("div", _hoisted_297, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalRelationshipScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalRelationshipMax'))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_298, [
                    _createElementVNode("div", _hoisted_299, [
                      _createVNode(_component_radial_progress, {
                        diameter: 80,
                        "stroke-width": 8,
                        "inner-stroke-width": 8,
                        "inner-stroke-color": '#FFFFFF',
                        "completed-steps": _ctx.placeVariable('TotalFairnessScore'),
                        "total-steps": _ctx.placeVariable('TotalFairnessMax'),
                        "start-color": '#3247b2',
                        "stop-color": '#3247b2',
                        "animate-speed": 800,
                        "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                      }, {
                        default: _withCtx(() => [...(_cache[193] || (_cache[193] = [
                          _createElementVNode("div", { id: "overall_fair_IMG" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["completed-steps", "total-steps"])
                    ]),
                    _createElementVNode("div", _hoisted_300, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalFairnessScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalFairnessMax'))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_301, [
                    _createElementVNode("div", _hoisted_302, [
                      _createVNode(_component_radial_progress, {
                        diameter: 80,
                        "stroke-width": 8,
                        "inner-stroke-width": 8,
                        "inner-stroke-color": '#FFFFFF',
                        "completed-steps": _ctx.placeVariable('TotalEquityScore'),
                        "total-steps": _ctx.placeVariable('TotalEquityMax'),
                        "start-color": '#32b285',
                        "stop-color": '#32b285',
                        "animate-speed": 800,
                        "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                      }, {
                        default: _withCtx(() => [...(_cache[194] || (_cache[194] = [
                          _createElementVNode("div", { id: "overall_equit_IMG" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["completed-steps", "total-steps"])
                    ]),
                    _createElementVNode("div", _hoisted_303, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalEquityScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('TotalEquityMax'))), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_304, [
                  _createElementVNode("div", {
                    id: "completion_replay_BTN",
                    onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.doChoice(1)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.storyChoices[1]), 1),
                    _cache[195] || (_cache[195] = _createElementVNode("div", { id: "replay_icon" }, null, -1))
                  ]),
                  _createElementVNode("div", {
                    id: "completion_return_BTN",
                    onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.doChoice(0)))
                  }, _toDisplayString(_ctx.storyChoices[0]), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_305, [
                _createElementVNode("div", _hoisted_306, [
                  _createElementVNode("div", {
                    id: "comp_level_title",
                    innerHTML: _ctx.tag('header3')
                  }, null, 8, _hoisted_307),
                  _createElementVNode("div", _hoisted_308, [
                    _createElementVNode("div", _hoisted_309, [
                      _createElementVNode("div", _hoisted_310, [
                        _createVNode(_component_radial_progress, {
                          diameter: 55,
                          "stroke-width": 4,
                          "inner-stroke-width": 4,
                          "inner-stroke-color": '#ffffff',
                          "completed-steps": _ctx.placeVariable('L1RelationshipScore'),
                          "total-steps": _ctx.placeVariable('L1RMax'),
                          "start-color": '#b23256',
                          "stop-color": '#b23256',
                          "animate-speed": 800,
                          "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                        }, {
                          default: _withCtx(() => [...(_cache[196] || (_cache[196] = [
                            _createElementVNode("div", { id: "comp_rela_IMG" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["completed-steps", "total-steps"])
                      ]),
                      _createElementVNode("div", _hoisted_311, [
                        _createElementVNode("div", _hoisted_312, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1RelationshipScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1RMax'))), 1),
                        _createElementVNode("div", {
                          id: "comp_scores_desc",
                          innerHTML: _ctx.tag('desc1')
                        }, null, 8, _hoisted_313)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_314, [
                      _createElementVNode("div", _hoisted_315, [
                        _createVNode(_component_radial_progress, {
                          diameter: 55,
                          "stroke-width": 4,
                          "inner-stroke-width": 4,
                          "inner-stroke-color": '#ffffff',
                          "completed-steps": _ctx.placeVariable('L1FairnessScore'),
                          "total-steps": _ctx.placeVariable('L1FMax'),
                          "start-color": '#3247b2',
                          "stop-color": '#3247b2',
                          "animate-speed": 800,
                          "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                        }, {
                          default: _withCtx(() => [...(_cache[197] || (_cache[197] = [
                            _createElementVNode("div", { id: "comp_fair_IMG" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["completed-steps", "total-steps"])
                      ]),
                      _createElementVNode("div", _hoisted_316, [
                        _createElementVNode("div", _hoisted_317, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1FairnessScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1FMax'))), 1),
                        _createElementVNode("div", {
                          id: "comp_scores_desc",
                          innerHTML: _ctx.tag('desc2')
                        }, null, 8, _hoisted_318)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_319, [
                      _createElementVNode("div", _hoisted_320, [
                        _createVNode(_component_radial_progress, {
                          diameter: 55,
                          "stroke-width": 4,
                          "inner-stroke-width": 4,
                          "inner-stroke-color": '#ffffff',
                          "completed-steps": _ctx.placeVariable('L1EquityScore'),
                          "total-steps": _ctx.placeVariable('L1EMax'),
                          "start-color": '#32b285',
                          "stop-color": '#32b285',
                          "animate-speed": 800,
                          "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                        }, {
                          default: _withCtx(() => [...(_cache[198] || (_cache[198] = [
                            _createElementVNode("div", { id: "comp_equit_IMG" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["completed-steps", "total-steps"])
                      ]),
                      _createElementVNode("div", _hoisted_321, [
                        _createElementVNode("div", _hoisted_322, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1EquityScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L1EMax'))), 1),
                        _createElementVNode("div", {
                          id: "comp_scores_desc",
                          innerHTML: _ctx.tag('desc3')
                        }, null, 8, _hoisted_323)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_324, [
                  _createElementVNode("div", {
                    id: "comp_level_title",
                    innerHTML: _ctx.tag('header4')
                  }, null, 8, _hoisted_325),
                  _createElementVNode("div", _hoisted_326, [
                    _createElementVNode("div", _hoisted_327, [
                      _createElementVNode("div", {
                        id: "comp_l2_title",
                        innerHTML: _ctx.tag('l2title1')
                      }, null, 8, _hoisted_328),
                      _createElementVNode("div", _hoisted_329, "$" + _toDisplayString(_ctx.formatNumber(_ctx.intVariable('ScenarioBudgetAssigned'))) + " - " + _toDisplayString(_ctx.formatNumber(_ctx.intVariable('ScenarioPercentage'))) + "%", 1),
                      _createElementVNode("div", {
                        id: "comp_l2_title",
                        innerHTML: _ctx.tag('l2title2')
                      }, null, 8, _hoisted_330),
                      _createElementVNode("div", _hoisted_331, [
                        _createElementVNode("div", _hoisted_332, [
                          _cache[199] || (_cache[199] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Student", -1)),
                          _createElementVNode("div", _hoisted_333, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountStudent'))), 1),
                          _createElementVNode("div", _hoisted_334, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('Student'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_335, [
                          _cache[200] || (_cache[200] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Intern", -1)),
                          _createElementVNode("div", _hoisted_336, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountIntern'))), 1),
                          _createElementVNode("div", _hoisted_337, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('Intern'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_338, [
                          _cache[201] || (_cache[201] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Masters", -1)),
                          _createElementVNode("div", _hoisted_339, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountMasters'))), 1),
                          _createElementVNode("div", _hoisted_340, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('Masters'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_341, [
                          _cache[202] || (_cache[202] = _createElementVNode("div", { id: "comp_l2_desc2" }, "PhD", -1)),
                          _createElementVNode("div", _hoisted_342, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountPhD'))), 1),
                          _createElementVNode("div", _hoisted_343, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('PhD'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_344, [
                          _cache[203] || (_cache[203] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Community Meeting", -1)),
                          _createElementVNode("div", _hoisted_345, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountCommunityMeeting'))), 1),
                          _createElementVNode("div", _hoisted_346, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CommunityMeeting'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_347, [
                          _cache[204] || (_cache[204] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Small Workshop", -1)),
                          _createElementVNode("div", _hoisted_348, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountSmallWorkshop'))), 1),
                          _createElementVNode("div", _hoisted_349, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('SmallWorkshop'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_350, [
                          _cache[205] || (_cache[205] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Community Event", -1)),
                          _createElementVNode("div", _hoisted_351, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountCommunityEvent'))), 1),
                          _createElementVNode("div", _hoisted_352, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CommunityEvent'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_353, [
                          _cache[206] || (_cache[206] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Capacity Building Program", -1)),
                          _createElementVNode("div", _hoisted_354, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountCapacityBuildingProgram'))), 1),
                          _createElementVNode("div", _hoisted_355, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CapacityBuildingProgram'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_356, [
                          _cache[207] || (_cache[207] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Community Advisory Group", -1)),
                          _createElementVNode("div", _hoisted_357, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountCommunityAdvisoryGroup'))), 1),
                          _createElementVNode("div", _hoisted_358, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CommunityAdvisoryGroup'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_359, [
                          _cache[208] || (_cache[208] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Consultant", -1)),
                          _createElementVNode("div", _hoisted_360, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountConsultant'))), 1),
                          _createElementVNode("div", _hoisted_361, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('Consultant'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_362, [
                          _cache[209] || (_cache[209] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Part Time Researcher", -1)),
                          _createElementVNode("div", _hoisted_363, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountPartTimeResearcher'))), 1),
                          _createElementVNode("div", _hoisted_364, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('PartTimeResearcher'))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_365, [
                          _cache[210] || (_cache[210] = _createElementVNode("div", { id: "comp_l2_desc2" }, "Full Time Researcher", -1)),
                          _createElementVNode("div", _hoisted_366, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('CountFullTimeResearcher'))), 1),
                          _createElementVNode("div", _hoisted_367, _toDisplayString(_ctx.formatNumber(_ctx.intVariable('FullTimeResearcher'))), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_368, [
                      _createElementVNode("div", _hoisted_369, [
                        _createElementVNode("div", _hoisted_370, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L2RelationshipScore'),
                            "total-steps": _ctx.placeVariable('L2RMax'),
                            "start-color": '#b23256',
                            "stop-color": '#b23256',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[211] || (_cache[211] = [
                              _createElementVNode("div", { id: "comp_rela_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps", "total-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_371, [
                          _createElementVNode("div", _hoisted_372, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2RelationshipScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2RMax'))), 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc4')
                          }, null, 8, _hoisted_373)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_374, [
                        _createElementVNode("div", _hoisted_375, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L2FairnessScore'),
                            "total-steps": _ctx.placeVariable('L2FMax'),
                            "start-color": '#3247b2',
                            "stop-color": '#3247b2',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[212] || (_cache[212] = [
                              _createElementVNode("div", { id: "comp_fair_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps", "total-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_376, [
                          _createElementVNode("div", _hoisted_377, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2FairnessScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2FMax'))), 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc5')
                          }, null, 8, _hoisted_378)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_379, [
                        _createElementVNode("div", _hoisted_380, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L2EquityScore'),
                            "total-steps": _ctx.placeVariable('L2EMax'),
                            "start-color": '#32b285',
                            "stop-color": '#32b285',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[213] || (_cache[213] = [
                              _createElementVNode("div", { id: "comp_equit_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps", "total-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_381, [
                          _createElementVNode("div", _hoisted_382, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2EquityScore'))) + "/" + _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L2EMax'))), 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc6')
                          }, null, 8, _hoisted_383)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_384, [
                  _createElementVNode("div", {
                    id: "comp_level_title",
                    innerHTML: _ctx.tag('header5')
                  }, null, 8, _hoisted_385),
                  _createElementVNode("div", _hoisted_386, [
                    _createElementVNode("div", _hoisted_387, [
                      _createElementVNode("div", {
                        id: "comp_l2_title",
                        innerHTML: _ctx.tag('l3title')
                      }, null, 8, _hoisted_388),
                      _createElementVNode("div", _hoisted_389, [
                        _cache[214] || (_cache[214] = _createElementVNode("div", { id: "comp_l3_desc" }, "1", -1)),
                        _createElementVNode("div", _hoisted_390, _toDisplayString(_ctx.getAllScores()[0].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_391, [
                        _cache[215] || (_cache[215] = _createElementVNode("div", { id: "comp_l3_desc" }, "2", -1)),
                        _createElementVNode("div", _hoisted_392, _toDisplayString(_ctx.getAllScores()[1].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_393, [
                        _cache[216] || (_cache[216] = _createElementVNode("div", { id: "comp_l3_desc" }, "3", -1)),
                        _createElementVNode("div", _hoisted_394, _toDisplayString(_ctx.getAllScores()[2].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_395, [
                        _cache[217] || (_cache[217] = _createElementVNode("div", { id: "comp_l3_desc" }, "4", -1)),
                        _createElementVNode("div", _hoisted_396, _toDisplayString(_ctx.getAllScores()[3].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_397, [
                        _cache[218] || (_cache[218] = _createElementVNode("div", { id: "comp_l3_desc" }, "5", -1)),
                        _createElementVNode("div", _hoisted_398, _toDisplayString(_ctx.getAllScores()[4].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_399, [
                        _cache[219] || (_cache[219] = _createElementVNode("div", { id: "comp_l3_desc" }, "6", -1)),
                        _createElementVNode("div", _hoisted_400, _toDisplayString(_ctx.getAllScores()[5].priority), 1)
                      ]),
                      _createElementVNode("div", _hoisted_401, [
                        _cache[220] || (_cache[220] = _createElementVNode("div", { id: "comp_l3_desc" }, "7", -1)),
                        _createElementVNode("div", _hoisted_402, _toDisplayString(_ctx.getAllScores()[6].priority), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_403, [
                      _createElementVNode("div", _hoisted_404, [
                        _createElementVNode("div", _hoisted_405, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L3RelationshipScore'),
                            "total-steps": 9,
                            "start-color": '#b23256',
                            "stop-color": '#b23256',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[221] || (_cache[221] = [
                              _createElementVNode("div", { id: "comp_rela_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_406, [
                          _createElementVNode("div", _hoisted_407, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L3RelationshipScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc7')
                          }, null, 8, _hoisted_408)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_409, [
                        _createElementVNode("div", _hoisted_410, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L3FairnessScore'),
                            "total-steps": 9,
                            "start-color": '#3247b2',
                            "stop-color": '#3247b2',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[222] || (_cache[222] = [
                              _createElementVNode("div", { id: "comp_fair_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_411, [
                          _createElementVNode("div", _hoisted_412, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L3FairnessScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc8')
                          }, null, 8, _hoisted_413)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_414, [
                        _createElementVNode("div", _hoisted_415, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L3EquityScore'),
                            "total-steps": 9,
                            "start-color": '#32b285',
                            "stop-color": '#32b285',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[223] || (_cache[223] = [
                              _createElementVNode("div", { id: "comp_equit_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_416, [
                          _createElementVNode("div", _hoisted_417, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L3EquityScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc9')
                          }, null, 8, _hoisted_418)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_419, [
                  _createElementVNode("div", {
                    id: "comp_level_title",
                    innerHTML: _ctx.tag('header6')
                  }, null, 8, _hoisted_420),
                  _createElementVNode("div", _hoisted_421, [
                    _createElementVNode("div", {
                      id: "comp_l4_row",
                      innerHTML: _ctx.tag('l4desc')
                    }, null, 8, _hoisted_422),
                    _createElementVNode("div", _hoisted_423, [
                      _createElementVNode("div", _hoisted_424, [
                        (_ctx.tag('PlayerTikiAward') == 'Gold')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_425))
                          : _createCommentVNode("", true),
                        (_ctx.tag('PlayerTikiAward') == 'Silver')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_426))
                          : _createCommentVNode("", true),
                        (_ctx.tag('PlayerTikiAward') == 'Bronze')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_427))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_428, [
                  _createElementVNode("div", {
                    id: "comp_level_title",
                    innerHTML: _ctx.tag('header7')
                  }, null, 8, _hoisted_429),
                  _createElementVNode("div", _hoisted_430, [
                    _createElementVNode("div", {
                      id: "comp_l5_row",
                      innerHTML: _ctx.tag('l5desc')
                    }, null, 8, _hoisted_431),
                    _createElementVNode("div", _hoisted_432, [
                      _createElementVNode("div", _hoisted_433, [
                        _createElementVNode("div", _hoisted_434, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L5RelationshipScore'),
                            "total-steps": 9,
                            "start-color": '#b23256',
                            "stop-color": '#b23256',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[224] || (_cache[224] = [
                              _createElementVNode("div", { id: "comp_rela_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_435, [
                          _createElementVNode("div", _hoisted_436, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L5RelationshipScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc10')
                          }, null, 8, _hoisted_437)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_438, [
                        _createElementVNode("div", _hoisted_439, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L5FairnessScore'),
                            "total-steps": 9,
                            "start-color": '#3247b2',
                            "stop-color": '#3247b2',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[225] || (_cache[225] = [
                              _createElementVNode("div", { id: "comp_fair_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_440, [
                          _createElementVNode("div", _hoisted_441, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L5FairnessScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc11')
                          }, null, 8, _hoisted_442)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_443, [
                        _createElementVNode("div", _hoisted_444, [
                          _createVNode(_component_radial_progress, {
                            diameter: 55,
                            "stroke-width": 4,
                            "inner-stroke-width": 4,
                            "inner-stroke-color": '#ffffff',
                            "completed-steps": _ctx.placeVariable('L5EquityScore'),
                            "total-steps": 9,
                            "start-color": '#32b285',
                            "stop-color": '#32b285',
                            "animate-speed": 800,
                            "timing-func": 'cubic-bezier(.3,.5,.8,.6)'
                          }, {
                            default: _withCtx(() => [...(_cache[226] || (_cache[226] = [
                              _createElementVNode("div", { id: "comp_equit_IMG" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["completed-steps"])
                        ]),
                        _createElementVNode("div", _hoisted_445, [
                          _createElementVNode("div", _hoisted_446, _toDisplayString(_ctx.formatNumber(_ctx.placeVariable('L5EquityScore'))) + "/9", 1),
                          _createElementVNode("div", {
                            id: "comp_scores_desc",
                            innerHTML: _ctx.tag('desc12')
                          }, null, 8, _hoisted_447)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[227] || (_cache[227] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'consentfailure')
          ? (_openBlock(), _createElementBlock("div", _hoisted_448, [
              _createElementVNode("div", _hoisted_449, [
                _createElementVNode("div", _hoisted_450, [
                  _createElementVNode("div", _hoisted_451, _toDisplayString(_ctx.tag('header')), 1),
                  _createElementVNode("div", _hoisted_452, [
                    _createElementVNode("div", {
                      id: "fail_desc",
                      innerHTML: _ctx.tag('description')
                    }, null, 8, _hoisted_453)
                  ]),
                  _createElementVNode("div", _hoisted_454, [
                    _createElementVNode("div", {
                      id: "fail_return_BTN",
                      onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.doChoice(0)))
                    }, [
                      _cache[228] || (_cache[228] = _createElementVNode("div", { id: "arrow_left_icon" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1)
                    ]),
                    _createElementVNode("div", {
                      id: "fail_restart_BTN",
                      onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.doChoice(1)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[1]), 1),
                      _cache[229] || (_cache[229] = _createElementVNode("div", { id: "replay_icon" }, null, -1))
                    ])
                  ])
                ])
              ]),
              _cache[230] || (_cache[230] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tag('screentype') == 'GameOver')
          ? (_openBlock(), _createElementBlock("div", _hoisted_455, [
              _createElementVNode("div", _hoisted_456, [
                _createElementVNode("div", _hoisted_457, [
                  _createElementVNode("div", _hoisted_458, _toDisplayString(_ctx.tag('header')), 1),
                  _createElementVNode("div", _hoisted_459, [
                    _createElementVNode("div", {
                      id: "over_desc",
                      innerHTML: _ctx.tag('description')
                    }, null, 8, _hoisted_460)
                  ]),
                  _createElementVNode("div", _hoisted_461, [
                    _createElementVNode("div", {
                      id: "over_return_BTN",
                      onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.doChoice(1)))
                    }, [
                      _cache[231] || (_cache[231] = _createElementVNode("div", { id: "arrow_left_icon" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[1]), 1)
                    ]),
                    _createElementVNode("div", {
                      id: "over_restart_BTN",
                      onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.doChoice(0)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.storyChoices[0]), 1),
                      _cache[232] || (_cache[232] = _createElementVNode("div", { id: "replay_icon" }, null, -1))
                    ])
                  ])
                ])
              ]),
              _cache[233] || (_cache[233] = _createElementVNode("div", { id: "default_background" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_462, [
              _createElementVNode("div", {
                class: "talk-pad",
                innerHTML: _ctx.storyText
              }, null, 8, _hoisted_463),
              _createElementVNode("div", _hoisted_464, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (value, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'tag'+key
                  }, _toDisplayString(key) + ":" + _toDisplayString(value), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_465, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (value, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'variable'+key
                  }, _toDisplayString(key) + ":" + _toDisplayString(value), 1))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "full-screen-cover",
                onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.doChoice(-1)))
              }),
              (_ctx.storyChoices.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_466, [
                    _cache[234] || (_cache[234] = _createElementVNode("div", { class: "option-overlay-bg full-screen-cover" }, null, -1)),
                    _createElementVNode("div", _hoisted_467, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyChoices, (choice, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'choice' + index,
                          class: "option",
                          innerHTML: choice,
                          onClick: ($event: any) => (_ctx.doChoice(index))
                        }, null, 8, _hoisted_468))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_469, [
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.goBack()))
                }, "Go Back"),
                _createElementVNode("div", {
                  class: "button",
                  onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.restartStory(null)))
                }, "Restart Story"),
                _createElementVNode("form", _hoisted_470, [
                  _createElementVNode("input", {
                    name: "file",
                    type: "file",
                    onChange: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_471, [
                _createElementVNode("div", {
                  class: "path-text",
                  innerHTML: _ctx.pathString
                }, null, 8, _hoisted_472)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    ])
  ]))
}